export default __webpack_public_path__ + "static/media/Schools.df18f05c.svg";